<!-- 智能名片数据分析 -->
<template>
  <div>
    <div class="head-title">数据统计</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、统计名片、文案中客户的访问详情、次数和时长等信息。</p>
          <p>2、智能名片获取阅读者的当前地理位置，后台详情中可点击查看。</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="navbar">
      <div class="nav-l">
        <div class="nav-l-item" :class="{ active: activeId === item.value }" v-for="item of tabs" :key="item.value"
          @click="onChangeTab(item)">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="mMain">
      <div class="filter">
        <div v-if="activeId == 'card'" style="width: 24.0rem" @click.stop="onSelectPerson">
          <el-input v-model="person.name" placeholder="选择成员" @change="clearD">
          </el-input>
        </div>
        <div v-else-if="activeId == 'text'" style="width: 24.0rem">
          <el-input v-model="q" placeholder="请输入标题搜索" @change="getText"></el-input>
        </div>
        <div style="margin-left: 2.4rem">
          <el-select v-model="type" placeholder="请选择周期" clearable @change="onChangeSelect">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div style="margin-left: 2.4rem">
          <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" :picker-options="pickerOptions" @change="onChangePicker">
          </el-date-picker>
        </div>
      </div>
      <div class="center">
        <div class="rank" id="rank" style="width: 100%; height: 50.0rem"></div>
      </div>
      <div class="main">
        <div class="head">详细数据</div>
        <div class="table">
          <el-table :data="list" style="width: 100%; margin-top: 2.0rem" border >
            <el-table-column v-if="activeId == 'card'" prop="name" label="名片" width="200">
            </el-table-column>
            <el-table-column v-else-if="activeId == 'text'" prop="name" label="标题" width="200">
            </el-table-column>
            <el-table-column label="访问位数">
              <template slot-scope="scope">
                <div>{{ scope.row.lookUserCount }}位</div>
              </template>
            </el-table-column>
            <el-table-column prop="time" label="访问时长">
              <template slot-scope="scope">
                <div>{{ scope.row.time }}分钟</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="170">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看访问者</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
              :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="getData" />
          </div>
        </div>
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
let ming = require("echarts/lib/echarts");
// 引入饼状图组件
require("echarts/lib/chart/pie");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "cardStatics",
  components: {
    rightPeople
  },

  data() {
    return {
      checkbox: false,
      cardList: [],
      textList: [],
      cardTopList: [],
      textTopList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      tabs: [
        {
          value: "card",
          label: "名片",
        },
        {
          value: "text",
          label: "文案",
        },
      ],
      activeId: "card",
      module: "",
      person: {
        name: "",
        userid: "",
      },
      type: "",
      time: [],
      options: [
        {
          label: "昨天",
          value: "yesterday",
        },
        {
          label: "今天",
          value: "tody",
        },
        {
          label: "本周",
          value: "week",
        },
        {
          label: "上周",
          value: "lastWeek",
        },
        {
          label: "本月",
          value: "month",
        },
        {
          label: "上月",
          value: "lastMonth",
        },
        {
          label: "本季度",
          value: "quarter",
        },
        {
          label: "上季度",
          value: "lastQuarter",
        },
        {
          label: "本年",
          value: "year",
        },
        {
          label: "去年",
          value: "lastYear",
        },
      ],
      pickerOptions: {
        disabledDate: (date) => {
          const time = date.getTime();
          return (
            time > Date.now() - 3600 * 1000 * 24 * 1 &&
            time > Date.now() - 3600 * 1000 * 24 * 30
          );
        },
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  computed: {
    topList() {
      return this.activeId === "card" ? this.cardTopList : this.textTopList;
    },
    list() {
      return this.activeId === "card" ? this.cardList : this.textList;
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    handleClick(row) {
      const activeId = this.activeId;
      let id;
      switch (activeId) {
        case "card":
          id = row.user_card_id;
          break;
        default:
          id = row.card_content_id;
          break;
      }
      this.$router.push({
        name: "cardStaticsUser",
        query: {
          id,
          activeId,
        },
      });
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
      this.getData();
    },
    onChangeSelect() {
      this.initGetData();
    },
    onChangePicker() {
      this.initGetData();
    },
    initGetData() {
      this.cardTopList = [];
      this.cardList = [];
      this.textTopList = [];
      this.textList = [];
      switch (this.activeId) {
        case "text":
          this.getText();
          break;
        default:
          this.getData();
          break;
      }
    },
    onChangeTab(item) {
      this.cardTopList = [];
      this.cardList = [];
      this.textTopList = [];
      this.textList = [];
      this.activeId = item.value;
      switch (this.activeId) {
        case "text":
          this.getText();
          break;
        default:
          this.getData();
          break;
      }
    },
    async getText() {
      let start_time = "";
      let end_time = "";
      if (this.time !== null && this.time.length) {
        start_time = parseInt(this.time[0].getTime() / 1000);
        end_time = parseInt(this.time[1].getTime() / 1000);
      }
      const { data: res } = await this.axios({
        url: "/crm/UserCard/getCardContentStatistics2",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          type: this.type,
          page: this.listQuery.page,
          title: this.q,
          start_time,
          end_time,
        }),
      });
      this.total = res.count;
      this.textTopList = res.data.slice(0, 10);
      this.textList = res.data;
      this.createEchart();
      if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    async getData() {
      let start_time = "";
      let end_time = "";
      if (this.time !== null && this.time.length) {
        start_time = parseInt(this.time[0].getTime() / 1000);
        end_time = parseInt(this.time[1].getTime() / 1000);
      }
      const { data: res } = await this.axios({
        url: "/crm/UserCard/getCardStatistics2",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          type: this.type,
          page: this.listQuery.page,
          number_page: this.listQuery.limit,
          userid: this.person.userid,
          start_time,
          end_time,
        }),
      });
      this.total = res.count;
      this.cardTopList = res.data.slice(0, 10);
      this.cardList = res.data;
      this.createEchart();
      if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    clearD() {
      if (this.person.name == "") {
        this.person.userid = "";
      }
      this.getData();
    },
    createEchart() {
      let names = [];
      let visits = [];
      let accessTime = [];
      this.list.forEach((i) => {
        names.push(i.name);
        visits.push(i.lookUserCount);
        accessTime.push(i.time);
      });
      console.log(visits);
      console.log(accessTime);
      let myChart = this.$echarts.init(document.getElementById("rank"));
      let color = [
        "#0090FF",
        "#36CE9E",
        "#FFC005",
        "#FF515A",
        "#8B5CFF",
        "#00CA69",
        "#44D7B6",
      ];
      let option = (option = {
        color,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        legend: {
          left: "center",
          top: "2%",
          data: ["访问位数", "访问时长"],
        },
        xAxis: [
          {
            type: "category",
            data: names,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "访问位数",
            type: "bar",
            data: visits,
          },
          {
            name: "访问时长",
            type: "bar",
            data: accessTime,
            emphasis: {
              // 高亮
              label: {
                show: false,
                textStyle: {
                  color: "#333333",
                  fontWeight: "bold",
                },
              },
            },
          },
        ],
      });
      myChart.setOption(option);
      myChart.dispatchAction({
        type: "downplay",

        // 用 index 或 id 或 name 来指定系列。
        // 可以使用数组指定多个系列。
        seriesIndex: 0,
        seriesName: "访问位数",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-l {
  width: 100%;
  display: flex;
}

.nav-l-item {
  margin: 0;
  margin-right: 1.0rem;
  padding: 0 2.1rem;
  line-height: 4.4rem;
  color: #888;
  font-size: 1.8rem;
  background: #f8f8f8;
  border-radius: 1.0rem 1.0rem .0rem .0rem;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  cursor: pointer;
}

.nav-l-item.active {
  line-height: 4.4rem;
  color: #000;
  background: #fdfefd;
  //border-color: #e8e8e8;
}

.center {
  margin-top: 2.0rem;
}

.filter {
  margin-top: 2.0rem;
  display: flex;
}
</style>
